const getters = {
	isSass:(state) => { //是否是加盟商
		const host = window.location.hostname;
		const isSass = host.indexOf(state.sassSuffix) !== -1;
		return isSass
	}
}
export default getters
